var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueCruise(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.993 13.5791V18.6582",
    stroke: "#2B7FFF",
    strokeWidth: 2.66552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.993 2.66504V6.66331",
    stroke: "#2B7FFF",
    strokeWidth: 2.66552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3224 17.3261V9.32958C25.3224 8.62264 25.0416 7.94466 24.5417 7.44477C24.0418 6.94489 23.3639 6.66406 22.6569 6.66406H9.32933C8.6224 6.66406 7.94441 6.94489 7.44453 7.44477C6.94465 7.94466 6.66382 8.62264 6.66382 9.32958V17.3261",
    stroke: "#2B7FFF",
    strokeWidth: 2.66552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8288 26.6551C27.2625 24.2356 28.009 21.4709 27.9879 18.6586L17.0753 13.8087C16.7346 13.6573 16.3659 13.5791 15.9931 13.5791C15.6203 13.5791 15.2516 13.6573 14.9109 13.8087L3.99827 18.6586C3.93657 22.4485 5.26934 26.1291 7.74332 29.0008",
    stroke: "#2B7FFF",
    strokeWidth: 2.66552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66553 27.988C3.46518 28.6544 4.26484 29.3208 5.99742 29.3208C9.32932 29.3208 9.32932 26.6553 12.6612 26.6553C14.3938 26.6553 15.1935 27.3217 15.9931 27.988C16.7928 28.6544 17.5924 29.3208 19.325 29.3208C22.6569 29.3208 22.6569 26.6553 25.9888 26.6553C27.7214 26.6553 28.521 27.3217 29.3207 27.988",
    stroke: "#2B7FFF",
    strokeWidth: 2.66552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCruise);
export default __webpack_public_path__ + "static/media/blue_cruise.df42313bf0f899b43079ea9f160f573c.svg";
export { ForwardRef as ReactComponent };